/* Session Engine — shared session picker (date strip + slots + inline question).
   Used by the product widget (all modes) and the Buy Now gate dialog.
   window.SEPicker.mount(container, data, { onConfirm, autoSelectDay, confirmLabel }) */
(function () {
  if (window.SEPicker) return;

  var CSS = [
    ".sep{font-family:var(--font-primary,'Manrope',sans-serif);color:#1f1f1f}",
    ".sep-head{display:flex;align-items:baseline;gap:10px;margin:0 0 12px}",
    ".sep-title{font-weight:700;font-size:16px;margin:0}",
    ".sep-count{font-size:12px;color:#858585}",
    ".sep-striprow{position:relative}",
    ".sep-strip{display:flex;gap:9px;overflow-x:auto;padding:2px 2px 12px;scroll-snap-type:x proximity;scrollbar-width:none;-webkit-overflow-scrolling:touch}",
    ".sep-strip::-webkit-scrollbar{display:none}",
    ".sep-fade{position:absolute;top:0;right:0;bottom:10px;width:56px;background:linear-gradient(90deg,transparent,#fff 80%);pointer-events:none}",
    ".sep-pad{position:absolute;top:50%;transform:translateY(-60%);width:34px;height:34px;border-radius:50%;border:1px solid #dbdad9;background:#fff;box-shadow:0 2px 10px rgba(20,30,25,.12);cursor:pointer;font-size:15px;color:#1f1f1f;display:none;align-items:center;justify-content:center;z-index:2}",
    "@media(hover:hover){.sep-pad{display:flex}}",
    ".sep-pad.prev{left:-8px}.sep-pad.next{right:-8px}",
    ".sep-pad:disabled{opacity:0;pointer-events:none}",
    ".sep-day{flex:none;scroll-snap-align:start;width:72px;border:1.5px solid #dbdad9;border-radius:14px;background:#fff;padding:10px 6px 9px;text-align:center;cursor:pointer;font:inherit;transition:border-color .12s,transform .12s}",
    ".sep-day:hover{border-color:#1f1f1f;transform:translateY(-1px)}",
    ".sep-day span{display:block;font-size:10px;color:#858585;text-transform:uppercase;letter-spacing:.08em;font-weight:700}",
    ".sep-day b{display:block;font-size:19px;line-height:1.25;font-weight:800}",
    ".sep-day i{display:block;font-style:normal;font-size:10px;color:#858585;text-transform:uppercase;letter-spacing:.08em;font-weight:600}",
    ".sep-day em{display:block;font-style:normal;font-size:9.5px;color:#f94d00;font-weight:700;margin-top:3px}",
    ".sep-day[aria-pressed=true]{border-color:#1f1f1f;background:#1f1f1f;color:#fff}",
    ".sep-day[aria-pressed=true] span,.sep-day[aria-pressed=true] i{color:rgba(255,255,255,.72)}",
    ".sep-day[aria-pressed=true] em{color:#ffb38a}",
    ".sep-split{display:grid;grid-template-columns:minmax(0,1fr) 168px;gap:16px;align-items:start}",
    "@media(max-width:640px){.sep-split{grid-template-columns:1fr;gap:12px}}",
    ".sep-cal-nav{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px}",
    ".sep-cal-nav button{border:1px solid #dbdad9;background:#fff;border-radius:8px;width:28px;height:28px;cursor:pointer;font:inherit;line-height:1;color:#1f1f1f}",
    ".sep-cal-nav button:disabled{opacity:.25;cursor:default}",
    ".sep-months{display:flex;gap:16px}",
    ".sep-month{flex:1;min-width:0}",
    "@media(max-width:640px){.sep-months{flex-direction:column;gap:14px}}",
    ".sep-mtitle{text-align:center;font-size:11.5px;font-weight:700;color:#858585;text-transform:uppercase;letter-spacing:.06em;margin:0 0 6px}",
    ".sep-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:2px}",
    ".sep-dow{text-align:center;font-size:9.5px;color:#999;font-weight:700;text-transform:uppercase;padding:1px 0}",
    ".sep-gd{aspect-ratio:1;border:none;background:none;border-radius:8px;font:inherit;font-size:12.5px;color:#d2d0ce;display:grid;place-items:center;position:relative}",
    ".sep-gd.has{color:#1f1f1f;font-weight:700;background:#f4f3f1;cursor:pointer}",
    ".sep-gd.has:hover{background:#e6e4e1}",
    ".sep-gd.has::after{content:'';position:absolute;bottom:3px;width:3px;height:3px;border-radius:50%;background:#1f1f1f;opacity:.3}",
    ".sep-gd.low::after{background:#f94d00;opacity:1}",
    ".sep-gd.sel{background:#1f1f1f!important;color:#fff}",
    ".sep-gd.sel::after{background:#fff;opacity:.85}",
    ".sep-times{border-left:1px solid #ebe9e7;padding-left:16px;min-height:150px}",
    "@media(max-width:640px){.sep-times{border-left:none;border-top:1px solid #ebe9e7;padding:12px 0 0;min-height:0}}",
    ".sep-times-label{font-size:11px;font-weight:700;color:#858585;text-transform:uppercase;letter-spacing:.06em;margin:0 0 8px}",
    ".sep-slots{display:flex;flex-direction:column;gap:6px;max-height:196px;overflow-y:auto}",
    "@media(max-width:640px){.sep-slots{flex-direction:row;flex-wrap:wrap;max-height:none}}",
    ".sep-slot{border:1.5px solid #dbdad9;border-radius:10px;background:#fff;padding:9px 12px;font:inherit;font-weight:700;font-size:13.5px;cursor:pointer;text-align:left;display:flex;justify-content:space-between;align-items:center;gap:10px;transition:border-color .12s}",
    ".sep-slot:hover{border-color:#1f1f1f}",
    ".sep-slot small{font-weight:600;font-size:10.5px;color:#858585}",
    ".sep-slot.low small{color:#f94d00}",
    ".sep-slot[aria-pressed=true]{border-color:#1f1f1f;background:#1f1f1f;color:#fff}",
    ".sep-slot[aria-pressed=true] small{color:rgba(255,255,255,.75)}",
    ".sep-empty-times{font-size:12.5px;color:#999;padding:4px 0}",
    ".sep-more{border:none;background:none;color:#1f1f1f;font-weight:700;font-size:13px;cursor:pointer;padding:12px 2px 2px;text-decoration:underline;text-underline-offset:3px;font-family:inherit}",
    ".sep-grid-wrap{margin-top:10px;border:1px solid #ebe9e7;border-radius:14px;padding:14px}",
    ".sep-foot{display:flex;align-items:center;gap:12px;margin-top:14px;padding-top:12px;border-top:1px solid #ebe9e7}",
    "@media(max-width:640px){.sep-foot{flex-direction:column;align-items:stretch;gap:10px}}",
    ".sep-picked{flex:1;min-width:0;font-size:13px;font-weight:700;color:#1f1f1f}",
    ".sep-picked span{display:block;font-weight:500;font-size:11.5px;color:#858585;margin-top:2px}",
    ".sep-cta{background:#f94d00;color:#fff;border:none;border-radius:100px;padding:13px 30px;font:inherit;font-weight:700;font-size:14.5px;cursor:pointer;white-space:nowrap}",
    ".sep-cta:hover{background:#e84900}",
    ".sep-cta:disabled{opacity:.3;cursor:default}",
    ".sep-q{display:block;margin-top:10px;font-size:11.5px;font-weight:700;color:#3d3d47}",
    ".sep-q input{width:100%;font:inherit;font-weight:400;font-size:13.5px;padding:9px 11px;border:1.5px solid #dbdad9;border-radius:10px;margin-top:4px;background:#fff;box-sizing:border-box}",
    /* Sub-16px inputs make iOS zoom the page on focus. */
    "@media(max-width:640px){.sep-q input{font-size:16px}}",
    ".sep-confirm{margin-top:14px;border:1.5px solid #1f1f1f;background:#f7f6f5;border-radius:13px;padding:14px 16px}",
    ".sep-confirm-line{display:flex;align-items:center;gap:8px;font-weight:700;font-size:14px}",
    ".sep-hold{font-size:11.5px;color:#3d3d47;font-weight:500;margin:3px 0 0}",
    ".sep-err{color:#9c3a2e;font-size:12.5px;margin:8px 0 0}",
    ".sep-wgate{display:flex;gap:8px;align-items:flex-start;margin-top:10px;font-size:12px;font-weight:600;color:#3d3d47;cursor:pointer;line-height:1.45}",
    ".sep-wgate input{width:15px;height:15px;margin-top:1px;flex:none;accent-color:#1f1f1f;cursor:pointer}",
    ".sep-wgate button{background:none;border:0;padding:0;font:inherit;color:#3d3d47;text-decoration:underline;text-underline-offset:2px;cursor:pointer}",
    ".sep-wgate.bad{color:#9c3a2e}.sep-wgate.bad button{color:#9c3a2e}",
    ".sep-empty{color:#3d3d47;font-size:14px;padding:8px 0}",
    ".sep-instead p{margin:0 0 11px;font-weight:600;color:#28282c}",
    ".sep-dates{display:flex;flex-direction:column;gap:6px}",
    ".sep-date{display:flex;align-items:center;justify-content:space-between;gap:12px;background:#f7f6f4;border:1px solid transparent;border-radius:11px;padding:10px 13px;text-decoration:none;color:#28282c}",
    ".sep-date:hover{background:#fff;border-color:#f94d00}",
    ".sep-date-when{font-size:13.5px;font-weight:700;line-height:1.3}",
    ".sep-date-at{display:block;font-style:normal;font-size:11.5px;font-weight:600;color:#8d8d95}",
    ".sep-date-go{flex:none;font-size:17px;line-height:1;color:#8d8d95}",
    ".sep-date:hover .sep-date-go{color:#f94d00}",
    ".sep-instead-more{display:inline-block;margin-top:11px;font-size:13px;font-weight:700;color:#f94d00;text-decoration:none}",
    ".sep-instead-more:hover{text-decoration:underline}",
  ].join("\n");

  /* Split view. Type resolves through the theme's own tokens — --font-primary
     (Manrope), the --fw-* weight ramp and the --step-* fluid scale — with the
     design's px as fallbacks, so the modal tracks the theme's responsive
     typography instead of shipping a second type system. */
  /* "Next Three" (choice reduction). Three near sessions as tappable rows with
     the first preselected, the month calendar behind one quiet link, and a CTA
     that always names what it books. Type resolves through the theme tokens. */
  var SPLIT_CSS = [
    ".sps{position:relative;--a:var(--blue,#2f6feb);--a-deep:var(--blue-dark,#2557c4);--tint:#e9f0fd;",
      "--ink:var(--primary,#111418);--ink2:#5f6672;--ink3:#8a9099;--fill:#f4f5f7;--fill2:#e8eaed;--line:#eef0f2;",
      "font-family:var(--font-primary,'Manrope',sans-serif);color:var(--ink);display:block;text-align:left}",
    ".sps-head{display:flex;justify-content:space-between;align-items:flex-start;gap:12px;padding:20px 22px 0}",
    ".sps-t{font-size:var(--font-body,17px);font-weight:var(--fw-bold,700);letter-spacing:-.015em;line-height:1.25}",
    ".sps-s{font-size:var(--small-size,12.5px);color:var(--ink2);margin-top:2px;font-weight:var(--fw-medium,500)}",
    ".sps-x{width:30px;height:30px;flex:none;border-radius:50%;border:0;background:var(--fill);color:var(--ink);display:grid;place-items:center;font-size:14px;cursor:pointer;font-family:inherit}",
    ".sps-x:hover{background:var(--fill2)}",
    ".sps-body{padding:16px 22px 18px;display:flex;flex-direction:column;gap:14px}",
    ".sps-rows{display:flex;flex-direction:column;gap:8px}",
    // display:flex beats the hidden attribute, so state it explicitly
    ".sps-rows[hidden]{display:none}",
    ".srow{display:flex;align-items:center;gap:12px;width:100%;border:0;border-radius:16px;background:#f7f8fa;padding:13px 14px;cursor:pointer;text-align:left;color:var(--ink);font-family:inherit;transition:background .12s}",
    ".srow.slocked{opacity:.55;cursor:default;pointer-events:none}",
    ".srow:hover{background:#eff1f4}",
    ".srow.on{background:var(--tint)}",
    ".srow:disabled{opacity:.45;cursor:default}",
    ".sradio{width:22px;height:22px;flex:none;border-radius:50%;border:2px solid #c9cdd3;display:grid;place-items:center;background:#fff;transition:border-color .12s,background .12s}",
    ".srow.on .sradio{border-color:var(--a);background:var(--a)}",
    ".sradio svg{opacity:0}.srow.on .sradio svg{opacity:1}",
    ".st{flex:1;min-width:0}",
    ".st b{display:block;font-size:var(--body-s-size,15px);font-weight:var(--fw-semibold,600);letter-spacing:-.01em}",
    ".st span{display:block;font-size:var(--caption-size,12px);color:var(--ink2);font-weight:var(--fw-medium,500);margin-top:1px}",
    ".sjoin{font-size:var(--caption-size,11.5px);font-weight:var(--fw-semibold,600);color:#1e7a4e;background:#e4f3ea;border-radius:999px;padding:4px 9px;white-space:nowrap;flex:none}",
    ".sjoin.warn{color:#9a6a0b;background:#fbefd4}",
    ".sjoin.cool{color:#2f6ab0;background:#e8f0fb}",
    ".sjoin.warm{color:#1e7a4e;background:#e4f3ea}",
    ".sjoin.hot{color:#b0338a;background:#fbe7f2}",
    /* The cut-off countdown carries a clock icon; the theme makes every svg a
       block, which stacked the icon above the words. */
    ".sjoin[data-closes]{display:inline-flex;align-items:center;gap:4px;font-variant-numeric:tabular-nums}",
    ".sjoin[data-closes] svg{display:inline-block;flex:none}",
    ".sps-more{background:none;border:0;cursor:pointer;text-align:center;color:var(--a);font-weight:var(--fw-semibold,600);padding:2px 0;font-size:var(--caption-size,11px);font-family:inherit}",
    ".sps-pick[hidden]{display:none}",
    ".sps-pick{display:flex;flex-direction:column;gap:10px}",
    ".cal-top{display:flex;align-items:baseline;justify-content:space-between;padding:0 2px}",
    ".cal-top b{font-size:var(--small-size,14px);font-weight:var(--fw-semibold,600)}",
    ".cal-top span{font-size:var(--caption-size,11.5px);color:var(--ink3);font-weight:var(--fw-medium,500)}",
    ".cal-nav{display:flex;gap:4px}",
    ".cal-nav button{width:32px;height:32px;border:1px solid #dfe2e6;border-radius:50%;background:#fff;color:var(--ink);cursor:pointer;font-family:inherit;font-size:19px;font-weight:var(--fw-bold,700);line-height:1;display:grid;place-items:center}",
    ".cal-nav button:hover{background:var(--fill)}.cal-nav button:disabled{opacity:.3;cursor:default}",
    ".cal-dow{display:grid;grid-template-columns:repeat(7,1fr);gap:4px;margin-top:10px;justify-items:center}",
    ".cal-dow i{font-style:normal;font-size:10px;font-weight:var(--fw-bold,700);letter-spacing:.06em;color:var(--ink3)}",
    ".cal-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:4px;margin-top:6px;justify-items:center}",
    ".cal-cell{width:40px;height:40px;border:0;border-radius:50%;background:transparent;font-size:var(--small-size,14px);font-weight:var(--fw-medium,500);color:var(--ink);cursor:pointer;display:grid;place-items:center;font-variant-numeric:tabular-nums;font-family:inherit;transition:background .12s}",
    ".cal-cell:hover{background:var(--fill)}",
    ".cal-cell.on,.cal-cell.on:hover{background:var(--a);color:#fff;font-weight:var(--fw-semibold,600)}",
    ".cal-cell:disabled,.cal-cell:disabled:hover{color:#c4c8ce;cursor:default;background:transparent}",
    ".sps-hair{border-top:1px solid var(--line)}",
    ".grow{display:flex;align-items:center;justify-content:space-between;gap:10px}",
    ".gl b{display:block;font-size:var(--small-size,14px);font-weight:var(--fw-semibold,600)}",
    ".gl span{display:block;font-size:var(--caption-size,11.5px);color:var(--ink3);font-weight:var(--fw-medium,500)}",
    ".gctl{display:flex;align-items:center;gap:2px;background:var(--fill);border-radius:999px;padding:3px}",
    ".gctl button{width:32px;height:32px;border:0;border-radius:50%;background:transparent;font-size:17px;cursor:pointer;color:var(--ink);display:grid;place-items:center;line-height:1;font-family:inherit}",
    ".gctl button:hover:not(:disabled){background:var(--fill2)}.gctl button:disabled{opacity:.3;cursor:default}",
    ".gctl b{min-width:26px;text-align:center;font-size:14.5px;font-weight:var(--fw-semibold,600);font-variant-numeric:tabular-nums}",
    ".sps-q{display:flex;flex-direction:column;gap:8px}.sps-q:empty{display:none}",
    ".sps-fld{display:flex;flex-direction:column;gap:4px}",
    ".sps-fld span{font-size:var(--caption-size,11px);font-weight:var(--fw-bold,700)}",
    ".sps-fld input{font-family:inherit;font-size:var(--body-s-size,14px);padding:10px 12px;border:1px solid #dfe2e6;border-radius:11px;background:#fff;color:var(--ink);width:100%;box-sizing:border-box}",
    ".sps-fld input:focus{border-color:var(--a);outline:none}",
    ".sps-fld input::placeholder{color:#9aa2ab;opacity:1}",
    ".sps-fld span i{font-weight:var(--fw-medium,500);color:var(--ink3);font-style:normal}",
    ".sps-fld input.bad{border-color:#c0392b}",
    ".gctl--locked{display:flex;align-items:center;padding:4px 14px;background:#fff;border:1px solid var(--sps-line2);border-radius:999px;font-weight:var(--fw-extrabold,800)}",
    ".sps-cta{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;border:0;border-radius:999px;background:var(--a);color:#fff;font-family:var(--font-primary,inherit);font-size:var(--font-button,15px);font-weight:var(--cta-font-weight,var(--fw-semibold,600));letter-spacing:-.01em;padding:15px 18px;cursor:pointer;transition:background .15s,transform .06s}",
    ".sps-cta:hover{background:var(--a-deep)}.sps-cta:active{transform:scale(.985)}",
    ".sps-note{font-size:var(--caption-size,11.5px);color:var(--ink3);text-align:center;font-weight:var(--fw-medium,500)}",
    /* The cancellation line is the last thing read before committing, so it is
       set apart from the muted grey the hold note used. Deliberately NOT the
       error red (.sps-err is #8f2411 on a pink chip, input.bad is #c0392b) --
       a reassurance that borrows the failure colour reads as a warning. */
    /* Brand orange via the token, not a literal: the colour experiment remaps
       --orange to --blue INSIDE the .jx-btn--orange selectors only, so the root
       token is still #f94d00 and this stays orange whatever that test is doing.
       Note the CTA beside it renders blue while ks-ab-color-b is at 100%. */
    ".sps-note--policy{display:flex;align-items:center;justify-content:center;gap:5px;color:var(--orange,#f94d00);font-weight:var(--fw-semibold,500);animation:sps-note-in .85s cubic-bezier(.22,.61,.36,1) 2s both}",
    /* Held 2s so it lands after the visitor has started reading times, then
       eases in over .85s -- long enough to read as something arriving rather
       than a repaint. `both` keeps it invisible until then, so a booking made
       inside the first 2s never sees it. Once, not looping: a loop beside a
       Book button reads as pressure rather than reassurance. */
    "@keyframes sps-note-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}",
    "@media(prefers-reduced-motion:reduce){.sps-note--policy{animation:none}}",
    ".sps-note--policy .sps-policy{background:none;border:0;padding:0;font:inherit;color:inherit;text-decoration:underline;text-underline-offset:2px;cursor:pointer}",
    ".sps-note--policy .sps-policy:hover{text-decoration-thickness:2px}",
    ".sps-note--policy svg{flex:none;width:13px;height:13px;opacity:.9}",
    /* Read-while-booking: the waiver is one quiet link in the hold note; the
       text opens in a small sheet on top of the picker. Signing still happens
       through the emailed per-booking link. */
    ".sps-wlink{background:none;border:0;padding:0;font:inherit;color:var(--ink3);text-decoration:underline;text-underline-offset:2px;cursor:pointer}",
    ".sps-wlink:hover{color:var(--ink)}",
    ".sps-wdlg{border:none;border-radius:16px;padding:0;width:min(560px,92vw);max-height:82dvh;",
      "font-family:var(--font-primary,'Manrope',sans-serif);box-shadow:0 30px 70px -25px rgba(0,0,0,.5)}",
    ".sps-wdlg::backdrop{background:rgba(20,28,24,.55)}",
    ".sps-wdlg .wh{display:flex;justify-content:space-between;align-items:center;gap:10px;padding:16px 20px;border-bottom:1px solid var(--line)}",
    ".sps-wdlg .wh b{font-size:var(--body-s-size,15px);font-weight:var(--fw-extrabold,800)}",
    ".sps-wdlg .wh button{border:0;background:var(--fill);border-radius:9px;width:30px;height:30px;cursor:pointer;color:var(--ink);font-size:13px}",
    ".sps-wdlg .wb{padding:16px 20px 20px;overflow-y:auto;max-height:calc(82dvh - 64px);-webkit-overflow-scrolling:touch;overscroll-behavior:contain}",
    ".sps-wdlg .wb p{margin:0 0 12px;font-size:var(--small-size,13.5px);line-height:1.65;color:var(--ink2)}",
    ".sps-wdlg .wb b{color:var(--ink)}",
    ".sps-wdlg .wf{margin:4px 0 0;font-size:var(--caption-size,11.5px);color:var(--ink3)}",
    /* Variant dropdown — the lamp-type picker moved inside the modal, styled
       after the signature hero's custom dropdown. */
    ".sps-dd{position:relative;margin:0 0 2px}",
    ".sps-dd-trigger{display:flex;align-items:center;gap:11px;width:100%;border:1px solid var(--line);border-radius:12px;padding:9px 13px 10px;background:#fff;cursor:pointer;text-align:left;font-family:inherit;transition:border-color .18s,box-shadow .18s}",
    ".sps-dd-trigger:hover{border-color:var(--ink2)}",
    ".sps-dd.open .sps-dd-trigger{border-color:var(--ink);box-shadow:0 0 0 3px rgba(40,40,44,.06)}",
    ".sps-dd-tx{flex:1;min-width:0}",
    ".sps-dd-label{display:block;font-size:10px;font-weight:var(--fw-extrabold,800);letter-spacing:.1em;text-transform:uppercase;color:var(--ink3);margin-bottom:2px}",
    ".sps-dd-value{display:flex;align-items:center;gap:9px;font-size:14.5px;font-weight:var(--fw-bold,700);color:var(--ink);min-width:0}",
    // The variant thumbnail is the only picture of what the guest is actually
    // buying — a lamp at 26px was unrecognisable. Big enough to tell a Standard
    // from a Swan from a Moon at a glance.
    ".sps-dd-value img{width:58px;height:58px;border-radius:11px;object-fit:cover;flex:none}",
    ".sps-dd-value .nm{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}",
    ".sps-dd-value .pr{margin-left:auto;font-weight:var(--fw-extrabold,800);white-space:nowrap}",
    ".sps-dd-chev{flex:none;width:24px;height:24px;border-radius:50%;background:var(--fill);display:grid;place-items:center;transition:transform .25s cubic-bezier(.4,.1,.4,1)}",
    ".sps-dd-chev svg{width:11px;height:11px;color:var(--ink2)}",
    ".sps-dd.open .sps-dd-chev{transform:rotate(180deg)}",
    ".sps-dd-panel{position:absolute;left:0;right:0;top:calc(100% + 6px);z-index:60;background:#fff;border:1px solid var(--line);border-radius:12px;box-shadow:0 24px 48px -20px rgba(20,28,24,.35);padding:6px;opacity:0;transform:translateY(-4px);pointer-events:none;transition:opacity .16s,transform .2s cubic-bezier(.3,.9,.4,1);max-height:400px;overflow:auto;overscroll-behavior:contain}",
    ".sps-dd.open .sps-dd-panel{opacity:1;transform:none;pointer-events:auto}",
    ".sps-dd-opt{display:flex;align-items:center;gap:11px;width:100%;padding:9px 11px;border-radius:9px;background:none;border:0;cursor:pointer;text-align:left;font-family:inherit;transition:background .14s}",
    ".sps-dd-opt:hover,.sps-dd-opt.focus{background:var(--fill)}",
    ".sps-dd-opt img{width:74px;height:74px;border-radius:12px;object-fit:cover;flex:none;background:var(--fill)}",
    ".sps-dd-opt .t{flex:1;min-width:0}",
    ".sps-dd-opt .n{display:block;font-size:14px;font-weight:var(--fw-bold,700);color:var(--ink);line-height:1.3}",
    ".sps-dd-opt .p{display:block;font-size:12px;color:var(--ink2);margin-top:1px}",
    ".sps-dd-opt .ck{flex:none;width:20px;height:20px;border-radius:50%;display:grid;place-items:center;opacity:0;transform:scale(.6);transition:.16s;background:var(--tint)}",
    ".sps-dd-opt .ck svg{width:10px;height:10px;color:var(--a)}",
    ".sps-dd-opt.on .ck{opacity:1;transform:scale(1)}",
    ".sps-dd-opt.on .n{color:var(--a)}",
    /* Quiet at rest, loud only at the moment it blocks: a plain muted line
       until the visitor tries to continue without it, when .bad reddens and
       shakes it. A bordered box here read as a warning the whole time. */
    ".sps-gate{display:flex;gap:8px;align-items:flex-start;padding:1px 0;cursor:pointer}",
    ".sps-gate input{width:15px;height:15px;margin-top:1px;flex:none;cursor:pointer;accent-color:var(--a)}",
    ".sps-gate span{font-size:var(--caption-size,11.5px);line-height:1.45;color:var(--ink2);font-weight:var(--fw-medium,500)}",
    ".sps-gate.bad span{color:#8f2411;font-weight:var(--fw-bold,700)}",
    ".sps-gate.bad{animation:sps-shake .3s ease 2}",
    "@keyframes sps-shake{0%,100%{transform:translateX(0)}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}",
    /* Booking overlay. Between the click and the checkout page there is a seat
       hold, a cart write and a page load — long enough that a button label
       alone reads as a frozen screen. This covers the modal so nothing else
       looks clickable, and shows which step is actually running. */
    ".sps-busy{position:absolute;inset:0;z-index:80;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;background:rgba(255,255,255,.93);backdrop-filter:blur(2px);opacity:0;pointer-events:none;transition:opacity .18s}",
    ".sps-busy.on{opacity:1;pointer-events:auto}",
    ".sps-ring{width:44px;height:44px;border-radius:50%;border:3px solid var(--line);border-top-color:var(--a);animation:sps-spin .8s linear infinite}",
    "@keyframes sps-spin{to{transform:rotate(360deg)}}",
    ".sps-busy-t{font-size:15px;font-weight:var(--fw-extrabold,800);color:var(--ink);text-align:center}",
    ".sps-busy-s{font-size:12.5px;color:var(--ink3);margin-top:-10px}",
    ".sps-steps{display:flex;align-items:center;gap:8px}",
    ".sps-step{width:7px;height:7px;border-radius:50%;background:var(--line);transition:background .25s,transform .25s}",
    ".sps-step.on{background:var(--a);transform:scale(1.35)}",
    ".sps-step.done{background:var(--a)}",
    ".sps-bar{width:170px;height:3px;border-radius:3px;background:var(--line);overflow:hidden}",
    ".sps-bar i{display:block;height:100%;width:40%;border-radius:3px;background:var(--a);animation:sps-slide 1.1s ease-in-out infinite}",
    "@keyframes sps-slide{0%{transform:translateX(-110%)}100%{transform:translateX(320%)}}",
    /* Anyone who asked the OS to calm motion down gets the state without the spin. */
    "@media (prefers-reduced-motion:reduce){.sps-ring{animation:none;border-top-color:var(--a)}.sps-bar i{animation:none;width:100%}}",
    ".sps-err{margin:0;font-size:var(--small-size,13px);font-weight:var(--fw-bold,700);color:#8f2411;background:#f8e4e0;border-radius:10px;padding:8px 12px}",
    ".sps-empty{color:var(--ink2);font-size:14px;padding:8px 0}",
    ".sps-scroll{display:flex;flex-direction:column;gap:14px}",
    ".sps-foot{display:flex;flex-direction:column;gap:10px}",
    /* Mobile: header fixed, middle scrolls, CTA pinned. overscroll-behavior
       stops the scroll chaining out to the page behind the sheet. */
    /* .hasabout included: its base display:block out-specifies .sps here and
       severed the flex chain. And .sps-main must pass flex/min-height through,
       or .sps-scroll never gets a bounded height and can't scroll — invisible
       with three rows, fatal once the month calendar opens. */
    "@media(max-width:720px){.sps,.sps.hasabout{display:flex;flex-direction:column;height:100%;min-height:88dvh}}",
    "@media(max-width:720px){.sps-main{flex:1;min-height:0;display:flex;flex-direction:column}}",
    "@media(max-width:720px){.sps-head{flex:none;padding:16px 16px 0}}",
    "@media(max-width:720px){.sps-body{flex:1;min-height:0;overflow:hidden;display:flex;flex-direction:column;gap:0;padding:14px 16px 0}}",
    /* Mobile: ONE scroll surface, and never a zero-height one.
       `flex:1 1 0; min-height:0` only resolves to a usable height when some
       ancestor has a definite one. On a surface where the dialog is auto-height
       that chain collapses to 0, so the session rows were laid out, present in
       the DOM, and invisible — while the calendar view (not flex-sized) still
       listed the same sessions. Hence "no schedule, but the calendar has it".
       A dvh cap plus a min-height floor makes the height self-sufficient, and
       letting the rows and the calendar size to content keeps this a single
       scroller rather than two fighting for the same flick. */
    "@media(max-width:720px){.sps-scroll{flex:1 1 0;min-height:0;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;padding-bottom:8px}}",
    "@media(max-width:720px){#sps-rows{flex:none;min-height:0;max-height:none;overflow:visible}}",
    "@media(max-width:720px){#sps-pick{max-height:none;overflow:visible}}",
    /* "Show more times" sits outside the scroller now, so it stays put
       as the dates scroll behind it — always one tap to the calendar. */
    "@media(max-width:720px){.sps-more{flex:none;padding:10px 0 6px}}",
    /* The dates own the top of the sheet on a phone: the list flexes to fill
       everything above the pinned footer and scrolls on its own, growing
       without limit as the visitor keeps going. The partial row at the cut
       line is the scroll cue. The id keeps #cal-slots (same class, inside the
       month view) out of it. */
    /* Desktop: the same scroller, capped at three rows with the fourth
       peeking. The list stays walkable to the end without opening the
       calendar, but the first glance is still three near options. */
    "@media(min-width:721px){#sps-rows{max-height:232px;overflow-y:auto;overscroll-behavior:contain;padding-right:2px}}",
    /* Now that .bd scrolls, the footer can pin here too — same contract as
       the phone sheet: the list is what scrolls, the decision stays on
       screen. Without it a short window scrolls the CTA out of sight. */
    "@media(min-width:721px){.sps-foot{position:sticky;bottom:0;background:#fff;padding-bottom:18px;z-index:2}}",
    /* The pinned footer separates with a hairline border; the inner hairline
       would double it. Tightened so guests + question + gate + CTA stay
       compact. And inputs hold 16px on phones — anything smaller makes iOS
       zoom the whole sheet the moment the field is focused. */
    "@media(max-width:720px){.sps-foot{gap:8px;padding-top:10px}.sps-foot .sps-hair{display:none}}",
    "@media(max-width:720px){.sps-fld input{font-size:16px}}",
    "@media(max-width:720px){.sps-foot .grow{padding:0}}",
    "@media(max-width:720px){.sps-foot{flex:none;position:sticky;bottom:0;background:#fff;padding:12px 0 calc(12px + env(safe-area-inset-bottom));border-top:1px solid var(--line)}}",
    /* Short phones. Measured on a 375x667 screen: the pinned footer took 253px
       of a 614px sheet, so three of ten class times were visible and the rest
       needed a scroll nobody makes. The optional mobile number is the single
       biggest piece of that at 69px and the hold note the least load-bearing,
       so on a short screen both give their height to the list -- five times
       visible instead of three. The scroller is flex:1, so it simply takes
       what the footer gives back; no JS involved.

       Keyed on HEIGHT as well as width, so a tall phone keeps the full footer
       and still offers the reminder. The input stays in the DOM rather than
       being removed: submit reads its value, and an empty one books fine.
       Placed after the rules above because it has to out-cascade the padding
       shorthand on the same selector, not because it is more specific. */
    "@media(max-width:720px) and (max-height:720px){.sps-phone{display:none}}",
    "@media(max-width:720px) and (max-height:720px){.sps-foot{gap:6px;padding-top:8px;padding-bottom:calc(8px + env(safe-area-inset-bottom))}}",
    "@media(max-width:720px) and (max-height:720px){.sps-head{padding:12px 16px 0}}",
    "@media(max-width:720px) and (max-height:720px){.sps-more{padding:6px 0 4px}}",
    "@media(max-width:720px){.cal-cell{width:38px;height:38px}}",
    /* Expanded on desktop: calendar beside the chosen day's sessions. The host
       dialogs set their width with an id selector, so widening needs the
       !important to win rather than a specificity arms race. */
    /* No display:block reset for .hasabout here: .sps is a plain block by
       default, and the reset's only real effect was out-specifying the mobile
       flex chain — which broke scrolling. Desktop grid arrives at 721px. */
    /* On a phone the listing info STAYS — hiding it left "Book your session"
       with no idea what was being booked. It compacts to a thumbnail strip
       (56px square, blurb clamped to two lines) so the picker still owns the
       height; desktop's photo column returns at 721px. */
    ".sps-about{display:flex;gap:12px;align-items:flex-start;padding:12px 16px 13px;background:#fafafb;border-bottom:1px solid var(--line);flex:none}",
    ".sps-about img{display:block;width:56px;height:56px;border-radius:12px;object-fit:cover;flex:none}",
    ".sps-abody{min-width:0}",
    "@media(max-width:720px){.sps-ablurb{margin-top:5px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}}",
    "@media(max-width:720px){.sps-alink{margin-top:6px}}",
    ".sps-atitle{font-size:var(--body-s-size,15px);font-weight:var(--fw-extrabold,800);line-height:1.25}",
    ".sps-ameta{font-size:var(--caption-size,11.5px);color:var(--ink2);font-weight:var(--fw-semibold,600);margin-top:3px}",
    ".sps-ablurb{margin:9px 0 0;font-size:var(--small-size,12.5px);line-height:1.55;color:var(--ink2);font-weight:var(--fw-medium,500)}",
    ".sps-alink{display:inline-block;margin-top:11px;font-size:var(--small-size,12.5px);font-weight:var(--fw-bold,700);color:var(--a);text-decoration:none}",
    ".sps-alink:hover{text-decoration:underline}",
    "@media(min-width:721px){.sps.hasabout{display:grid;grid-template-columns:236px minmax(0,1fr)}}",
    "@media(min-width:721px){.sps.hasabout .sps-about{display:block;padding:0;border-bottom:none;background:#fafafb;border-right:1px solid var(--line)}}",
    "@media(min-width:721px){.sps-about img{width:100%;height:150px;border-radius:0}}",
    "@media(min-width:721px){.sps-abody{padding:14px 16px 16px}}",
    "@media(min-width:721px){dialog.sps-about-on{width:min(720px,94vw)!important}}",
    "@media(min-width:721px){dialog.sps-about-on.sps-wide{width:min(960px,94vw)!important}}",
    "@media(min-width:721px){dialog.sps-wide:not(.sps-about-on){width:min(700px,94vw)!important}}",
    "@media(min-width:721px){.sps.wide .sps-pick{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:20px;align-items:start}}",
    "@media(min-width:721px){.sps.wide #cal-slots{max-height:300px;overflow-y:auto;padding-right:2px}}",
    "@media(min-width:721px){.sps.wide #cal-slots:empty::after{content:\'Pick a day to see its times\';display:block;font-size:12.5px;color:var(--ink3);padding:6px 2px}}",
  ].join("\n");

  /* Cancellation terms, shown under the CTA.

     The WINDOW is the experiment (A = 48 hours, B = 24), so the number is read
     from the arm rather than written into the string. ab-head sets the html
     class before anything here runs; KS_AB is the fallback for a page where the
     engine came up late. Both default to 48 -- the conservative arm, because
     under-promising costs a little conversion and over-promising costs a
     refund we said we would give. */
  var CAL_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<rect x="3" y="5" width="18" height="16" rx="3"></rect>' +
    '<path d="M8 3v4M16 3v4M3 11h18"></path></svg>';

  /* Private-only workshops publish a fixed 7-day cancellation policy
     (content-tabs-meta.liquid's Cancellation Policy tab and section-faq.liquid
     both state it, and the paused 'risk' hero line suppresses itself on these
     pages for the same reason) -- it is NOT part of the 'cancel' A/B test,
     which only ever varies the public 24h/48h wording. The hero section
     rendered from the Event metaobject (collection-hero-meta.liquid) is the
     single source of truth for which policy applies to this page: it prints
     .hero-cta-caption--private exactly when the metaobject's only_private
     field is true. Reading that at open time -- rather than duplicating the
     metaobject flag into picker options, which could drift out of sync --
     means the modal can never show a policy the hero itself isn't also
     showing. Checked fresh on every call, not cached, since se-picker mounts
     once per page load and the hero is already in the DOM by then. */
  function isPrivateHero() {
    return !!document.querySelector(".hero-cta-caption--private");
  }

  function cancelArm() {
    var c = document.documentElement.classList;
    if (c.contains("ks-ab-cancel-b")) return "b";
    if (c.contains("ks-ab-cancel-a")) return "a";
    var x = window.KS_AB && window.KS_AB.cancel;
    return x && x.variant === "b" ? "b" : "a";
  }
  function cancelHours() {
    if (isPrivateHero()) return 24 * 7;
    return cancelArm() === "b" ? 24 : 48;
  }

  function cancelNote() {
    if (isPrivateHero()) {
      return "Free cancellation up to 7 days before &middot; " +
        '<button type="button" class="sps-policy" id="sps-policy">Details</button>' +
        CAL_ICON;
    }
    /* What is being tested is whether naming a window helps or gets in the way,
       so arm A makes the bare claim and arm B spells the deadline out. Either
       way the real terms are one tap away in Details, which always states the
       arm's actual window -- vague in the line is fine, vague in the policy is
       not. */
    var lead = cancelArm() === "b"
      ? "Free cancellation up to " + cancelHours() + " hours before"
      : "Free cancellation";
    return lead + " &middot; " +
      '<button type="button" class="sps-policy" id="sps-policy">Details</button>' +
      CAL_ICON;
  }

  /* The summary opens in place rather than sending anyone to a policy page:
     this is read mid-decision, with a seat held, and a new tab is where that
     decision goes to die. Written from the live rule, not around it -- the
     window is whatever arm the visitor is in (or the private-only override),
     refunds are cash, and the private-booking exception is stated rather than
     buried. */
  function policyHtml() {
    if (isPrivateHero()) {
      return "<p><b>Free cancellation.</b> Cancel more than 7 days before your class " +
          "and we refund the full amount to the card you paid with. No form, no questions.</p>" +
        "<p><b>Inside 7 days.</b> We can&rsquo;t refund a cancellation this late &mdash; " +
          "the studio and the makers are already reserved around your group.</p>" +
        "<p><b>Rescheduling.</b> Private bookings can&rsquo;t be moved: the studio and the " +
          "makers are reserved around your group. If your group size changes, contact us and " +
          "we&rsquo;ll do our best to accommodate it.</p>" +
        '<p class="wf">Anything unusual &mdash; illness, travel, a group that changed size &mdash; ' +
          'email hello@kraftstories.com. We&rsquo;d rather hear from you than have you not come.</p>';
    }
    var h = cancelHours();
    return "<p><b>Free cancellation.</b> Cancel more than " + h + " hours before your class " +
        "and we refund the full amount to the card you paid with. No form, no questions.</p>" +
      "<p><b>Inside " + h + " hours.</b> We can&rsquo;t refund a cancellation this late &mdash; " +
        "your materials are already prepped and the seat is out of circulation.</p>" +
      "<p><b>Rescheduling.</b> Moving to another public date is free, up to the same " + h +
        "-hour mark. Private bookings can&rsquo;t be moved: the studio and the makers are " +
        "reserved around your group.</p>" +
      '<p class="wf">Anything unusual &mdash; illness, travel, a group that changed size &mdash; ' +
        'email hello@kraftstories.com. We&rsquo;d rather hear from you than have you not come.</p>';
  }

  /* Page scroll lock.
     showModal() blocks interaction behind a dialog but does not stop the page
     scrolling — most visibly on iOS. State is derived from the DOM rather than
     counted, because mountSplit runs again on every open: a per-mount flag let
     the second observer capture an already-locked value and restore "hidden"
     on close, leaving the page permanently stuck. Reading whether any dialog
     is open is idempotent, so any number of observers can call it safely. */
  var LOCK_PREV = null;
  function syncScrollLock() {
    var anyOpen = !!document.querySelector("dialog[open]");
    var el = document.documentElement;
    if (anyOpen && LOCK_PREV === null) {
      LOCK_PREV = el.style.overflow || "";
      el.style.overflow = "hidden";
    } else if (!anyOpen && LOCK_PREV !== null) {
      el.style.overflow = LOCK_PREV;
      LOCK_PREV = null;
    }
  }

  /* One observer per dialog, however many times we mount into it. */
  function watchDialog(host) {
    if (!host || host.__sepScrollWatched || !window.MutationObserver) return;
    host.__sepScrollWatched = true;
    new MutationObserver(syncScrollLock).observe(host, { attributes: true, attributeFilter: ["open"] });
    host.addEventListener("close", syncScrollLock);
    host.addEventListener("cancel", syncScrollLock);
  }

  function injectSplitCss() {
    injectCss();
    if (document.getElementById("sps-css")) return;
    var st = document.createElement("style");
    st.id = "sps-css"; st.textContent = SPLIT_CSS;
    document.head.appendChild(st);
  }

  function injectCss() {
    if (document.getElementById("sep-css")) return;
    var st = document.createElement("style");
    st.id = "sep-css"; st.textContent = CSS;
    document.head.appendChild(st);
  }

  /* One escaper for the module. mountSplit carried an identical copy of its
     own; the empty state needs it too, and two is one more than the number of
     ways HTML should be escaped in one file. */
  function esc(t) {
    return String(t == null ? "" : t).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  /* What an empty calendar says.
   *
   * Normally "check back soon", which is right for a class we cannot sell yet.
   * But some classes have no dates HERE and plenty somewhere else — Sip & Plant
   * does not run in Midtown while the same workshop runs in the Financial
   * District — and the engine says so in `instead`, having re-checked that the
   * alternative really does have dates. Then a guest who came ready to book is
   * given somewhere they can.
   *
   * The sep-empty / sps-empty class stays on the wrapper either way: it is what
   * the analytics beacon reads to record that the calendar came up empty, and
   * that is still exactly what happened. */
  function emptyHtml(cls, data) {
    var go = data && data.instead;
    var plain = "No upcoming dates right now \u2014 check back soon, or contact us for private bookings.";
    /* Every field it is about to render, not just the object: an engine on an
       older version answers with the object and without the dates, and a
       half-applied rewrite shows a guest an empty heading over nothing. */
    if (!go || !go.url || !go.heading || !go.dates || !go.dates.length) {
      return '<p class="' + cls + '">' + plain + "</p>";
    }
    /* Blank for a different class at the same studio: naming the studio under
       three of its own dates, on its own page, is filler. */
    var where = go.rowLabel == null ? (go.venueShort || go.venue || "") : go.rowLabel;
    return '<div class="' + cls + ' sep-instead">' +
      "<p>" + esc(go.heading) + "</p>" +
      '<div class="sep-dates">' +
      go.dates.map(function (dt) {
        /* A chevron, not a seat count: three rows all saying "50 seats" tell a
           guest the room is empty, which is the opposite of what a list of
           dates is for. */
        return '<a class="sep-date" href="' + esc(go.url) + '">' +
          '<span class="sep-date-when">' + esc(dt.label) +
          (where ? '<i class="sep-date-at">' + esc(where) + "</i>" : "") + "</span>" +
          '<span class="sep-date-go" aria-hidden="true">\u203a</span></a>';
      }).join("") +
      "</div>" +
      '<a class="sep-instead-more" href="' + esc(go.url) + '">' + esc(go.moreLabel || "See all dates") + " \u2192</a>" +
      "</div>";
  }

  function group(sessions) {
    var by = {};
    sessions.forEach(function (s) { (by[s.local_date] = by[s.local_date] || []).push(s); });
    return by;
  }

  /* A booking add must land in a cart with no other session in it. Checkout
     abandoned and retried, times reconsidered, back buttons — each left the
     previous session line behind, and the guest paid for two. Sweep every
     line carrying _session_id (kits, gifts and merch stay) before adding. */
  function freshCart() {
    return fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var stale = (c.items || []).filter(function (i) { return i.properties && i.properties._session_id; });
        var chain = Promise.resolve();
        stale.forEach(function (i) {
          chain = chain.then(function () {
            return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: i.key, quantity: 0 }) });
          });
        });
        return chain;
      })
      .catch(function () { /* a failed sweep must never block the booking */ });
  }

  window.SEPicker = {
    freshCart: freshCart,
    /* The private-hold pane (snippets/private-hold.liquid) draws its calendar
       and start times with this picker's own classes, so the two can never
       look like different products; it needs the stylesheet without a mount. */
    css: injectSplitCss,
    mount: function (root, data, opts) {
      injectCss();
      opts = opts || {};
      var sessions = data.sessions || [];
      var byDate = group(sessions);
      var availDates = Object.keys(byDate).filter(function (d) {
        return byDate[d].some(function (s) { return s.seats_available > 0; });
      }).sort();
      var state = { day: null, session: null, gridOpen: false, gridMonth: null };

      if (!availDates.length) {
        root.innerHTML = emptyHtml("sep-empty", data);
        if (opts.onEmpty) opts.onEmpty();
        return;
      }
      if (opts.autoSelectDay !== false) state.day = availDates[0];

      function labelFor(iso) {
        var d = new Date(iso + "T12:00:00");
        var today = new Date(); today.setHours(12, 0, 0, 0);
        var diff = Math.round((d - today) / 86400000);
        var dow = d.toLocaleDateString("en-US", { weekday: "short" });
        var num = d.getDate();
        var mon = d.toLocaleDateString("en-US", { month: "short" });
        return { top: diff === 0 ? "Today" : diff === 1 ? "Tmrw" : dow, big: String(num), sub: mon };
      }

      // How many months to show: 2 when the current month is nearly spent.
      function monthCount() {
        var months = monthList();
        if (months.length < 2) return 1;
        var openOn = state.day || availDates[0];
        var firstM = openOn.slice(0, 7);
        var inFirst = availDates.filter(function (d) { return d.slice(0, 7) === firstM; }).length;
        // "Close to end of the month": the first date we land on sits in the
        // final third of its month, so a single grid would look nearly spent.
        var day = Number(openOn.slice(8, 10));
        var ref = new Date(openOn + "T12:00:00");
        var dim = new Date(ref.getFullYear(), ref.getMonth() + 1, 0).getDate();
        var nearEnd = (dim - day) <= 10;
        return (inFirst <= 6 || nearEnd) ? 2 : 1;
      }
      function monthList() {
        var months = [];
        availDates.forEach(function (d) { var m = d.slice(0, 7); if (months.indexOf(m) < 0) months.push(m); });
        return months;
      }

      function render() {
        var html = '<div class="sep">';
        if (opts.layout === "months") {
          html += '<div class="sep-split"><div id="sep-grid"></div>' +
            '<div class="sep-times"><p class="sep-times-label" id="sep-tl">Select a date</p>' +
            '<div class="sep-slots" id="sep-slots"></div></div></div>' +
            '<div id="sep-sel"></div>';
        } else {
          html += '<div class="sep-head"><p class="sep-title">Pick your date</p>' +
            '<span class="sep-count">' + availDates.length + " dates available</span></div>" +
            '<div class="sep-striprow"><button type="button" class="sep-pad prev" aria-label="Earlier dates">‹</button>' +
            '<div class="sep-strip" role="listbox" aria-label="Available dates">';
          availDates.slice(0, 28).forEach(function (d) {
            var l = labelFor(d);
            var spots = byDate[d].reduce(function (a, s) { return a + Math.max(s.seats_available, 0); }, 0);
            html += '<button type="button" class="sep-day" role="option" aria-pressed="' + (state.day === d) + '" data-d="' + d + '">' +
              "<span>" + l.top + "</span><b>" + l.big + "</b><i>" + l.sub + "</i>" +
              (spots <= 6 ? "<em>" + spots + " left</em>" : "") + "</button>";
          });
          html += '</div><div class="sep-fade"></div><button type="button" class="sep-pad next" aria-label="Later dates">›</button></div>' +
            '<p class="sep-times-label" id="sep-tl"></p><div class="sep-slots" id="sep-slots"></div>' +
            '<button type="button" class="sep-more" id="sep-more">' + (state.gridOpen ? "Hide calendar ▴" : "Browse all dates ▾") + '</button>' +
            '<div id="sep-grid-inline"></div><div id="sep-sel"></div>';
        }
        html += "</div>";
        root.innerHTML = html;

        root.querySelectorAll(".sep-day").forEach(function (b) {
          b.addEventListener("click", function () { state.day = b.dataset.d; state.session = null; render(); });
        });
        var strip = root.querySelector(".sep-strip");
        if (strip) {
          var sel = strip.querySelector('[aria-pressed="true"]');
          if (sel) sel.scrollIntoView({ block: "nearest", inline: "center" });
          root.querySelectorAll(".sep-pad").forEach(function (p) {
            p.addEventListener("click", function () {
              strip.scrollBy({ left: p.classList.contains("next") ? 280 : -280, behavior: "smooth" });
            });
          });
        }
        var more = root.querySelector("#sep-more");
        if (more) more.addEventListener("click", function () { state.gridOpen = !state.gridOpen; render(); });

        if (opts.layout === "months") renderGrid(root.querySelector("#sep-grid"), monthCount());
        else if (state.gridOpen) renderGrid(root.querySelector("#sep-grid-inline"), 1);
        renderSlots();
        renderSel();
      }

      function renderSlots() {
        var el = root.querySelector("#sep-slots");
        var lab = root.querySelector("#sep-tl");
        if (!el) return;
        if (!state.day) {
          el.innerHTML = opts.layout === "months" ? '<p class="sep-empty-times">Pick a highlighted day to see times.</p>' : "";
          return;
        }
        var d = new Date(state.day + "T12:00:00");
        if (lab) lab.textContent = d.toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric" });
        el.innerHTML = (byDate[state.day] || []).map(function (s) {
          var full = s.seats_available < 1, low = !full && s.seats_available <= 3;
          return '<button type="button" class="sep-slot' + (low ? " low" : "") + '" data-id="' + s.id + '"' +
            (full ? " disabled style='opacity:.4;cursor:default'" : "") +
            ' aria-pressed="' + (state.session && state.session.id === s.id) + '">' +
            "<span>" + s.local_time + "</span><small>" + (full ? "sold out" : s.seats_available + " left") + "</small></button>";
        }).join("");
        el.querySelectorAll(".sep-slot:not([disabled])").forEach(function (b) {
          b.addEventListener("click", function () {
            state.session = sessions.find(function (s) { return s.id === b.dataset.id; });
            render();
          });
        });
      }

      function renderGrid(target, count) {
        if (!target) return;
        var months = monthList();
        if (!state.gridMonth || months.indexOf(state.gridMonth) < 0) {
          state.gridMonth = (state.day || availDates[0]).slice(0, 7);
        }
        var mi = months.indexOf(state.gridMonth);
        if (count > 1 && mi > months.length - count) mi = Math.max(0, months.length - count);
        var shown = months.slice(mi, mi + count);
        function shownFirst() { return shown[0]; }
        var bare = opts.layout === "months";
        var html = (bare ? '<div>' : '<div class="sep-grid-wrap">') + '<div class="sep-cal-nav">' +
          '<button type="button" data-nav="-1"' + (mi <= 0 ? " disabled" : "") + ' aria-label="Earlier">‹</button>' +
          '<span style="font-size:12.5px;font-weight:700">' + (count === 1 ? new Date(shownFirst(mi, count) + "-01T12:00:00").toLocaleDateString("en-US", { month: "long", year: "numeric" }) : "") + "</span>" +
          '<button type="button" data-nav="1"' + (mi + count >= months.length ? " disabled" : "") + ' aria-label="Later">›</button></div>' +
          '<div class="sep-months">';
        shown.forEach(function (mkey) {
          var first = new Date(mkey + "-01T12:00:00");
          var lead = first.getDay();
          var dim = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate();
          html += '<div class="sep-month">' + (count > 1 ? '<p class="sep-mtitle">' +
            first.toLocaleDateString("en-US", { month: "long" }) + "</p>" : "") +
            '<div class="sep-grid">' +
            ["S", "M", "T", "W", "T", "F", "S"].map(function (d) { return '<span class="sep-dow">' + d + "</span>"; }).join("");
          for (var i = 0; i < lead; i++) html += "<span></span>";
          for (var day = 1; day <= dim; day++) {
            var key = mkey + "-" + String(day).padStart(2, "0");
            var ss = byDate[key] || [];
            var spots = ss.reduce(function (a, s) { return a + Math.max(s.seats_available, 0); }, 0);
            var has = spots > 0, low = has && spots <= 6;
            html += '<button type="button" class="sep-gd' + (has ? " has" : "") + (low ? " low" : "") +
              (key === state.day ? " sel" : "") + '"' + (has ? ' data-d="' + key + '"' : " disabled tabindex='-1'") + ">" + day + "</button>";
          }
          html += "</div></div>";
        });
        html += "</div></div>";
        target.innerHTML = html;
        target.querySelectorAll("[data-nav]").forEach(function (b) {
          b.addEventListener("click", function () {
            state.gridMonth = months[Math.min(Math.max(mi + Number(b.dataset.nav), 0), months.length - 1)];
            render();
          });
        });
        target.querySelectorAll(".sep-gd.has").forEach(function (b) {
          b.addEventListener("click", function () { state.day = b.dataset.d; state.session = null; render(); });
        });
      }

      function renderSel() {
        var el = root.querySelector("#sep-sel");
        if (!el) return;
        var qs = (data.experience && data.experience.intake_questions) || [];
        // Redemption reuses this picker but has no checkout, so callers can
        // replace the hold wording (holdNote: "" drops it entirely).
        var holdLong = opts.holdNote == null ? "Your spot is held 15 minutes while you check out" : opts.holdNote;
        var holdShort = opts.holdNote == null ? "held 15 min while you check out" : opts.holdNote;
        if (!state.session) {
          if (opts.confirmLabel) {
            el.innerHTML = '<div class="sep-foot"><div class="sep-picked">Choose a date and time' +
              (holdLong ? "<span>" + holdLong + "</span>" : "") + "</div>" +
              '<button type="button" class="sep-cta" disabled>' + opts.confirmLabel + "</button></div>";
          } else { el.innerHTML = ""; }
          if (opts.onClear) opts.onClear();
          return;
        }
        var s = state.session;
        var qHtml = qs.map(function (q, i) {
          return '<label class="sep-q">' + q.label +
            '<input type="text" data-qi="' + i + '" placeholder="' + (q.required ? "Required" : "Optional") + '"></label>';
        }).join("");
        if (opts.confirmLabel) {
          var sub = [s.venue || "", holdShort].filter(Boolean).join(" · ");
          el.innerHTML = qHtml +
            '<label class="sep-wgate" id="sep-wgate"><input type="checkbox" id="sep-wgate-cb" checked>' +
              '<span>I agree to the <button type="button" id="sep-wlink">liability waiver</button> for everyone in my party.</span></label>' +
            '<p class="sep-err" id="sep-werr" hidden>Please agree to the liability waiver to book.</p>' +
            '<div class="sep-foot"><div class="sep-picked">' + s.local_label +
            (sub ? "<span>" + sub + "</span>" : "") + "</div>" +
            '<button type="button" class="sep-cta" id="sep-cta">' + opts.confirmLabel + "</button></div>";
        } else {
          el.innerHTML = '<div class="sep-confirm"><div class="sep-confirm-line">✓ ' + s.local_label +
            (s.venue ? " · " + s.venue : "") + "</div>" +
            (holdLong ? '<p class="sep-hold">' + holdLong + ".</p>" : "") + qHtml + "</div>";
        }
        var answers = function () {
          var out = {};
          el.querySelectorAll("[data-qi]").forEach(function (inp) {
            var q = qs[Number(inp.dataset.qi)];
            if (inp.value.trim()) out[q.label] = inp.value.trim();
          });
          return out;
        };
        if (opts.confirmLabel) {
          var wg = el.querySelector("#sep-wgate"), wgCb = el.querySelector("#sep-wgate-cb");
          var werr = el.querySelector("#sep-werr"), wl = el.querySelector("#sep-wlink");
          if (wl) wl.addEventListener("click", function (ev) {
            ev.preventDefault(); ev.stopPropagation();
            window.open("https://book.kraftstories.com/waiver", "_blank", "noopener");
          });
          if (wgCb) wgCb.addEventListener("change", function () {
            if (wgCb.checked) { werr.hidden = true; wg.classList.remove("bad"); }
          });
          el.querySelector("#sep-cta").addEventListener("click", function () {
            if (wgCb && !wgCb.checked) {
              werr.hidden = false;
              wg.classList.remove("bad"); void wg.offsetWidth; wg.classList.add("bad");
              wgCb.focus();
              return;
            }
            var a = answers();
            a["_waiver_agreed"] = "yes";
            opts.onConfirm(s, a);
          });
        } else if (opts.onConfirm) {
          opts.onConfirm(s, answers);
        }
      }

      render();
    },

    /* Split view: session list beside a live receipt. Every type value below
       resolves through the theme's tokens (--font-primary, --fw-*, --step-*)
       with the prototype's px as the fallback, so the modal inherits Manrope
       and the theme's responsive scale instead of shipping its own font. */
    mountSplit: function (root, data, opts) {
      injectSplitCss();
      opts = opts || {};
      /* Sold-out and privately-booked slots stay VISIBLE — a full calendar is
         proof the studio runs, and scarcity sells the next date. They render
         locked and are never selectable; `sessions` stays the bookable list,
         so byId, seat clamps and every caller's empty-schedule behaviour are
         untouched. */
      var pool = (data.sessions || []).slice();
      (data.booked_slots || []).forEach(function (b) {
        b.seats_available = 0; b.locked_private = true;
        pool.push(b);
      });
      pool.sort(function (a, b2) {
        return String(a.starts_at_utc) < String(b2.starts_at_utc) ? -1 : String(a.starts_at_utc) > String(b2.starts_at_utc) ? 1 : 0;
      });
      var sessions = pool.filter(function (s) { return s.seats_available > 0; });
      var byDate = group(pool);
      var dates = Object.keys(byDate).sort();
      var title = (data.experience && data.experience.title) || "Your booking";
      var NEXT_N = 3;
      // Variant selection lives in the modal now: a dropdown when there's a
      // real choice, silent when there's only one.
      var variants = (opts.variants || []).slice();
      var hasVariants = variants.length > 1;

      if (!dates.length) {
        root.innerHTML = emptyHtml("sps-empty", data);
        if (opts.onEmpty) opts.onEmpty();
        return;
      }

      /* Classes that carry an age restriction. The tufting gun is not suitable
         for younger children, so every tufting booking must confirm the group
         is 14+ before it can continue. Matched on the title so all six studio
         variants are covered by one rule. */
      var AGE_GATE = [
        { match: "tufting", min: 14, why: "the tufting gun isn&rsquo;t suitable for younger children" },
      ];
      var gate = null;
      (function () {
        var t = String(title || "").toLowerCase();
        for (var i = 0; i < AGE_GATE.length; i++) {
          if (t.indexOf(AGE_GATE[i].match) > -1) { gate = AGE_GATE[i]; return; }
        }
      })();

      /* Redeeming a gift reuses this whole view, but the seats are already
         bought and already paid for: lockSeats fixes the count and hides the
         stepper, and prepaid drops the price from the CTA and the hold note. */
      var lockSeats = opts.lockSeats ? Math.max(1, opts.lockSeats) : null;
      /* Someone who told the finder "2 guests" has already answered this
         question; opening on 1 asks it again and quietly under-books a party
         that clicks straight through. Unlike lockSeats this stays editable —
         it is a starting value, not a constraint — and the capacity clamp in
         paint() still trims it to what the chosen session can actually seat. */
      var startGuests = lockSeats || Math.max(1, Math.floor(Number(opts.guests)) || 1);
      var st = { session: null, guests: startGuests, open: false, month: dates[0].slice(0, 7) };
      var CHECK = '<svg width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 6.4 5 8.9 9.7 3.4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      function money(c) { return "$" + (c / 100).toFixed(c % 100 ? 2 : 0); }
      function pad(n) { return (n < 10 ? "0" : "") + n; }
      function relDay(iso) {
        var d = new Date(iso + "T12:00:00"), t = new Date(); t.setHours(12, 0, 0, 0);
        var away = Math.round((d - t) / 86400000);
        if (away === 0) return "Today";
        if (away === 1) return "Tomorrow";
        return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
      }
      /* Real bookings only. This used to fall back to a hash-seeded 2..5
         "others" whenever a session had none yet, so most of the schedule
         carried a number nobody had earned. A count a guest weighs a booking
         against has to be true, so an empty session now says nothing at all
         and the badge means what it says. */
      function joiners(sess) {
        return sess.seats_taken > 0 ? sess.seats_taken : 0;
      }

      /* The cut-off as a countdown. A slot today stops selling some time before
         it starts (the studio's cut-off, or the class's own — the engine sends
         the instant as closes_at_utc). Saying so beats the slot silently
         disappearing on the next visit, and it is a true deadline, not
         invented urgency. Only today's slots count down; later days are calm. */
      var CLOCK = '<svg width="11" height="11" viewBox="0 0 12 12" fill="none" aria-hidden="true"><circle cx="6" cy="6" r="4.6" stroke="currentColor" stroke-width="1.4"/><path d="M6 3.6V6l1.7 1.1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
      function msToClose(sess) {
        var t = sess.closes_at_utc ? Date.parse(sess.closes_at_utc) : NaN;
        return isNaN(t) ? null : t - Date.now();
      }
      /* Seconds run (owner): "Closes in 4h 52m 08s", "Closes in 52m 08s". */
      function closeLabel(ms) {
        var t = Math.max(0, Math.ceil(ms / 1000));
        var h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), sec = t % 60;
        return "Closes in " + (h ? h + "h " + pad(m) + "m " : m + "m ") + pad(sec) + "s";
      }
      function closingToday(sess) {
        var ms = msToClose(sess);
        return ms != null && ms > 0 && relDay(sess.local_date) === "Today";
      }

      /* Every bookable session in time order, rendered as a capped scroller
         on every screen: three rows visible (the fourth peeking out as the
         scroll cue), the rest by scrolling — appending in batches until the
         whole schedule has been walked. Choice reduction still holds: three
         near options are what a visitor sees first. */
      var ALL = [];
      for (var di = 0; di < dates.length; di++) {
        var dayS = byDate[dates[di]];
        for (var dj = 0; dj < dayS.length; dj++) ALL.push(dayS[dj]);
      }
      /* opts.initialRows: how many rows exist before any growth. The dialog
         keeps 10 and grows them by scrolling; the Focus hero starts smaller
         and grows on a button, because a nested scroller on a phone traps
         the page. */
      var shown = Math.min(opts.initialRows || 10, ALL.length);
      // Never auto-select a locked row: the first BOOKABLE session is the default.
      st.session = null;
      for (var ai = 0; ai < ALL.length; ai++) {
        if (ALL[ai].seats_available > 0) { st.session = ALL[ai]; break; }
      }

      /* Opened from a calendar or a card, the visitor may never have seen the
         class page. opts.about puts the photo, the blurb and a way through to
         the full listing beside the picker, without making them leave. */
      var ab = opts.about || null;
      root.innerHTML =
        '<div class="sps' + (ab ? " hasabout" : "") + '">' +
          (ab ?
            '<aside class="sps-about">' +
              (ab.image ? '<img src="' + esc(ab.image) + '" alt="">' : "") +
              '<div class="sps-abody">' +
                '<div class="sps-atitle">' + esc(ab.title || "") + "</div>" +
                (ab.meta ? '<div class="sps-ameta">' + esc(ab.meta) + "</div>" : "") +
                (ab.blurb ? '<p class="sps-ablurb">' + esc(ab.blurb) + "</p>" : "") +
                (ab.url ? '<a class="sps-alink" href="' + esc(ab.url) + '">View full details &rarr;</a>' : "") +
              "</div>" +
            "</aside>" : "") +
          '<div class="sps-main">' +
          '<div class="sps-head"><div>' +
            '<div class="sps-t">' + esc(opts.heading || "Book your session") + "</div>" +
            '<div class="sps-s">' + esc(title) + " &middot; " + esc(sessions[0].venue) + "</div>" +
          "</div>" +
          (opts.onClose ? '<button type="button" class="sps-x" id="sps-x" aria-label="Close">&#10005;</button>' : "") +
          "</div>" +
          '<div class="sps-body">' +
            '<div class="sps-scroll" id="sps-scroll">' +
            (hasVariants ?
              '<div class="sps-dd" id="sps-vdd">' +
                '<button type="button" class="sps-dd-trigger" aria-haspopup="listbox" aria-expanded="false">' +
                  '<span class="sps-dd-tx"><span class="sps-dd-label">' + esc(opts.variantLabel || "Option") + '</span>' +
                  '<span class="sps-dd-value" id="sps-vv"></span></span>' +
                  '<span class="sps-dd-chev"><svg viewBox="0 0 12 12" fill="none"><path d="M2.5 4.5 6 8l3.5-3.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
                "</button>" +
                '<div class="sps-dd-panel" role="listbox" id="sps-vp"></div>' +
              "</div>" : "") +
            '<div class="sps-rows" id="sps-rows"></div>' +
            '<div class="sps-pick" id="sps-pick" hidden>' +
              '<div><div class="cal-top"><b id="cal-label"></b>' +
                '<span class="cal-nav"><button type="button" id="cal-prev" aria-label="Previous month">&lsaquo;</button>' +
                '<button type="button" id="cal-next" aria-label="Next month">&rsaquo;</button></span></div>' +
                '<div class="cal-dow"><i>S</i><i>M</i><i>T</i><i>W</i><i>T</i><i>F</i><i>S</i></div>' +
                '<div class="cal-grid" id="cal-grid"></div></div>' +
              '<div class="sps-rows" id="cal-slots"></div>' +
            "</div>" +
            "</div>" +
            '<button type="button" class="sps-more" id="sps-more">See calendar view &#9662;</button>' +
            /* Guests, questions and the gate live in the footer: on a phone
               the footer is pinned, so they snap above the CTA and the whole
               area above belongs to the sessions. Desktop reads identically —
               these blocks always sat directly over the footer anyway. */
            '<div class="sps-foot">' +
            '<div class="sps-hair"></div>' +
            (lockSeats
              ? '<div class="grow"><span class="gl"><b>Guests</b><span id="g-sub"></span></span>' +
                '<span class="gctl gctl--locked"><b id="g-n">' + lockSeats + "</b></span></div>"
              : '<div class="grow"><span class="gl"><b>Guests</b><span id="g-sub">Just you</span></span>' +
                '<span class="gctl"><button type="button" data-d="-1" aria-label="Fewer">&minus;</button>' +
                '<b id="g-n">1</b><button type="button" data-d="1" aria-label="More">+</button></span></div>') +
            '<div class="sps-fld sps-phone"><span>Mobile number <i>&middot; optional &mdash; we&rsquo;ll text you a reminder before class</i></span>' +
            '<input id="sps-phone-in" type="tel" inputmode="tel" autocomplete="tel" placeholder="(555) 123-4567"></div>' +
            '<div class="sps-q" id="sps-q"></div>' +
            (gate ?
              '<label class="sps-gate" id="sps-gate"><input type="checkbox" id="sps-gate-cb">' +
                "<span>Everyone attending is " + gate.min + " or older" +
                (gate.why ? " &mdash; " + gate.why : "") + ".</span></label>" : "") +
              '<label class="sps-gate" id="sps-wgate"><input type="checkbox" id="sps-wgate-cb" checked>' +
                '<span>I agree to the <button type="button" class="sps-wlink" id="sps-wlink">liability waiver</button> for everyone in my party.</span></label>' +
              '<p class="sps-err" id="sps-err" hidden></p>' +
              '<button type="button" class="sps-cta" id="sps-cta"></button>' +
              '<p class="sps-note' + (opts.note ? "" : " sps-note--policy") + '">' +
              (opts.note || cancelNote()) + "</p>" +
            "</div>" +
          "</div>" +
          "</div>" +
        "</div>";

      var rowsEl = root.querySelector("#sps-rows");
      var pickEl = root.querySelector("#sps-pick");
      var moreEl = root.querySelector("#sps-more");
      var gridEl = root.querySelector("#cal-grid");
      var calSlots = root.querySelector("#cal-slots");
      var labelEl = root.querySelector("#cal-label");
      var ctaEl = root.querySelector("#sps-cta");
      var errEl = root.querySelector("#sps-err");
      var gN = root.querySelector("#g-n"), gSub = root.querySelector("#g-sub");
      var qWrap = root.querySelector("#sps-q");

      /* Waiver, readable in place. One shared dialog per page, text fetched
         once and cached on the element; stacks on top of the picker dialog. */
      var wlink = root.querySelector("#sps-wlink");
      if (wlink) wlink.addEventListener("click", function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        var wd = document.getElementById("sps-wdlg");
        if (!wd) {
          wd = document.createElement("dialog");
          wd.id = "sps-wdlg"; wd.className = "sps-wdlg";
          wd.setAttribute("aria-label", "Liability waiver");
          wd.innerHTML = '<div class="wh"><b>Liability waiver</b><button type="button" aria-label="Close">&#10005;</button></div><div class="wb"><p>Loading&hellip;</p></div>';
          document.body.appendChild(wd);
          wd.querySelector(".wh button").addEventListener("click", function () { wd.close(); });
          wd.addEventListener("click", function (e) { if (e.target === wd) wd.close(); });
          watchDialog(wd);
        }
        wd.showModal();
        if (!wd.__loaded) {
          fetch("https://book.kraftstories.com/api/waiver")
            .then(function (r) { return r.json(); })
            .then(function (w) {
              wd.__loaded = true;
              wd.querySelector(".wh b").textContent = w.title || "Liability waiver";
              wd.querySelector(".wb").innerHTML = (w.body_html || "") +
                '<p class="wf">You&rsquo;ll get a link to sign this with your confirmation &mdash; one signature covers your whole party.</p>';
            })
            .catch(function () {
              wd.querySelector(".wb").innerHTML =
                "<p>Couldn&rsquo;t load the waiver just now &mdash; it&rsquo;s also linked from your confirmation email.</p>";
            });
        }
      });

      var qs = (data.experience && data.experience.intake_questions) || [];
      qWrap.innerHTML = qs.map(function (q, i) {
        return '<label class="sps-fld"><span>' + esc(q.label) + "</span>" +
          '<input type="text" data-qi="' + i + '" placeholder="' + (q.required ? "Required" : "Optional") + '"></label>';
      }).join("");
      function answers() {
        var out = {};
        qWrap.querySelectorAll("[data-qi]").forEach(function (inp) {
          var q = qs[Number(inp.dataset.qi)];
          if (inp.value.trim()) out[q.label] = inp.value.trim();
        });
        return out;
      }

      function rowHTML(sess, on) {
        var left = sess.seats_available, tight = left <= 4;
        if (left < 1) {
          var ltag = sess.closed ? "Booking closed" : sess.locked_private ? "Booked · private" : "Sold out";
          var llead = relDay(sess.local_date);
          var lsub = opts.hideVenue ? sess.local_time : sess.local_time + " · " + sess.venue;
          return '<div class="srow slocked">' +
            '<span class="st"><b>' + esc(llead) + "</b><span>" + esc(lsub) + "</span></span>" +
            '<span class="sjoin hot">' + ltag + "</span></div>";
        }
        /* The day leads everywhere a visitor is choosing between dates; only
           the monthly widget, where the date is already the column, leads with
           the time. A literal middot: this string goes through esc(), which
           would turn an HTML entity into visible "&middot;" text. */
        var lead = relDay(sess.local_date);
        /* opts.hideVenue: the Focus hero mounts this under a facts grid that
           already names the studio, and every row is that same studio — so the
           venue repeated once per row. The dialog still shows it. */
        var sub = opts.hideVenue ? sess.local_time : sess.local_time + " \u00b7 " + sess.venue;
        /* Two signals only, same rule as the hero card: scarcity when the room
           is genuinely filling, otherwise social proof, otherwise silence. A
           raw "50 spots left" argues against booking. */
        var pill = "";
        if (closingToday(sess)) {
          var cms = msToClose(sess);
          pill = '<span class="sjoin ' + (cms < 1800000 ? "hot" : "warn") + '" data-closes="' + esc(sess.closes_at_utc) + '">' +
            CLOCK + "<span>" + closeLabel(cms) + "</span></span>";
        } else if (tight) {
          pill = '<span class="sjoin warn">Only ' + left + " left</span>";
        } else {
          var j = joiners(sess);
          if (j) {
            var band = j >= 5 ? "hot" : j >= 3 ? "warm" : "cool";
            pill = '<span class="sjoin ' + band + '">Join ' + j + " other" + (j === 1 ? "" : "s") + "</span>";
          }
        }
        return '<button type="button" class="srow' + (on ? " on" : "") + '" data-id="' + sess.id + '">' +
          '<span class="sradio">' + CHECK + "</span>" +
          '<span class="st"><b>' + esc(lead) + "</b><span>" + esc(sub) + "</span></span>" +
          pill + "</button>";
      }
      function paintRows() {
        rowsEl.innerHTML = ALL.slice(0, shown).map(function (x) {
          return rowHTML(x, st.session && x.id === st.session.id);
        }).join("");
      }
      /* Append-only growth: insertAdjacentHTML never rebuilds existing rows,
         so the scroll position can't jump while the visitor is mid-flick. */
      function growRows() {
        if (shown >= ALL.length) return;
        var start = shown;
        shown = Math.min(shown + 8, ALL.length);
        var html = "";
        for (var gi = start; gi < shown; gi++) {
          html += rowHTML(ALL[gi], st.session && ALL[gi].id === st.session.id);
        }
        rowsEl.insertAdjacentHTML("beforeend", html);
      }
      /* Infinite scroll follows whichever element actually scrolls — the
         rows list on desktop (capped), the whole scroll surface on mobile
         (where the rows size to content). Only a genuinely scrolling element
         satisfies scrollHeight > clientHeight, so this can't misfire. */
      function nearBottom(el) {
        return el.scrollHeight > el.clientHeight &&
               el.scrollTop + el.clientHeight >= el.scrollHeight - 140;
      }
      var growScroll = root.querySelector("#sps-scroll");
      [rowsEl, growScroll].forEach(function (el) {
        if (el) el.addEventListener("scroll", function () { if (nearBottom(el)) growRows(); });
      });
      function paintCta() {
        var s = st.session;
        var verb = opts.ctaVerb || "Book";
        var unit = (st.variant && st.variant.price_cents != null) ? st.variant.price_cents : (s ? s.price_cents : 0);
        ctaEl.textContent = s
          ? verb + " · " + relDay(s.local_date) + " " + s.local_time +
            (opts.prepaid ? "" : " — " + money(unit * st.guests))
          : (opts.ctaEmpty || (pool.length ? "Sold out" : "Choose a time"));
        ctaEl.disabled = !s;
        var cap = s ? s.seats_available : 8;
        if (!lockSeats && st.guests > cap) st.guests = Math.max(cap, 1);
        gN.textContent = st.guests;
        gSub.textContent = lockSeats
          ? (lockSeats === 1 ? "Prepaid seat" : lockSeats + " prepaid seats")
          : (st.guests === 1 ? "Just you" : st.guests + " people");
        if (lockSeats) return;   // the stepper is not rendered in locked mode
        root.querySelector('.gctl [data-d="-1"]').disabled = st.guests <= 1;
        root.querySelector('.gctl [data-d="1"]').disabled = st.guests >= cap;
      }
      // Selected variant drives the CTA price and the eventual add.
      var vv = root.querySelector("#sps-vv"), vp = root.querySelector("#sps-vp"), vdd = root.querySelector("#sps-vdd");
      st.variant = hasVariants ? variants[0] : (variants[0] || null);
      function paintVValue() {
        if (!vv) return;
        var v = st.variant;
        vv.innerHTML = (v.image ? '<img src="' + esc(v.image) + '" alt="">' : "") +
          '<span class="nm">' + esc(v.title) + "</span>" +
          (v.price_cents != null ? '<span class="pr">' + money(v.price_cents) + "</span>" : "");
      }
      function paintVPanel() {
        vp.innerHTML = variants.map(function (v, i) {
          return '<button type="button" class="sps-dd-opt' + (v.id === st.variant.id ? " on" : "") + '" role="option" data-i="' + i + '" aria-selected="' + (v.id === st.variant.id) + '">' +
            (v.image ? '<img src="' + esc(v.image) + '" alt="">' : "") +
            '<span class="t"><span class="n">' + esc(v.title) + "</span>" +
            (v.price_cents != null ? '<span class="p">' + money(v.price_cents) + "</span>" : "") + "</span>" +
            '<span class="ck"><svg viewBox="0 0 12 12" fill="none"><path d="M2 6.2 4.8 9 10 3.4" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg></span></button>';
        }).join("");
      }
      if (hasVariants) {
        var vtrig = vdd.querySelector(".sps-dd-trigger");
        var scrollBox = root.querySelector("#sps-scroll");
        paintVValue();

        /* The dropdown lives INSIDE #sps-scroll, which scrolls — and an
           absolutely positioned panel is clipped by any overflow ancestor, so
           the list was being cut off and painted under whatever came next.
           Positioning it fixed against the trigger takes it out of that clip
           entirely, and it is measured on every open because the trigger moves
           as the modal scrolls. */
        function placeVPanel() {
          var r = vtrig.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var vw = window.innerWidth || document.documentElement.clientWidth;
          var below = vh - r.bottom - 12, above = r.top - 12;
          var up = below < 200 && above > below;   // no room under it — flip up
          // Clamped to the viewport, never just copied from the trigger: a
          // measurement taken before a rotation or an address-bar collapse would
          // otherwise leave the panel wider than the screen or half off it.
          var w = Math.min(r.width, vw - 16);
          var left = Math.max(8, Math.min(r.left, vw - w - 8));
          vp.style.position = "fixed";
          vp.style.left = Math.round(left) + "px";
          vp.style.width = Math.round(w) + "px";
          vp.style.right = "auto";
          vp.style.zIndex = "999";
          vp.style.maxHeight = Math.max(160, Math.round(up ? above : below)) + "px";
          if (up) { vp.style.top = "auto"; vp.style.bottom = Math.round(vh - r.top + 6) + "px"; }
          else { vp.style.bottom = "auto"; vp.style.top = Math.round(r.bottom + 6) + "px"; }
        }
        function openVdd() {
          paintVPanel();
          vdd.classList.add("open");
          vtrig.setAttribute("aria-expanded", "true");
          placeVPanel();
          // While the list is open the page behind it must stay put: the panel
          // is fixed, so a scrolling background would slide out from under it.
          // Only the panel scrolls, and only when it is longer than the space.
          if (scrollBox) scrollBox.style.overflow = "hidden";
        }
        function closeVdd() {
          vdd.classList.remove("open");
          vtrig.setAttribute("aria-expanded", "false");
          if (scrollBox) scrollBox.style.overflow = "";
        }
        vtrig.addEventListener("click", function () {
          if (vdd.classList.contains("open")) closeVdd(); else openVdd();
        });
        vp.addEventListener("click", function (e) {
          var b = e.target.closest(".sps-dd-opt"); if (!b) return;
          st.variant = variants[Number(b.dataset.i)];
          paintVValue(); closeVdd();
          paintCta();
        });
        document.addEventListener("click", function (e) {
          if (vdd.classList.contains("open") && !vdd.contains(e.target) && !vp.contains(e.target)) closeVdd();
        });
        // A fixed panel cannot follow the page, so re-measure on resize and
        // step aside if anything outside the modal scrolls.
        window.addEventListener("resize", function () {
          if (vdd.classList.contains("open")) placeVPanel();
        });
        window.addEventListener("scroll", function () {
          if (vdd.classList.contains("open")) closeVdd();
        }, true);
        document.addEventListener("keydown", function (e) {
          if (e.key === "Escape" && vdd.classList.contains("open")) { closeVdd(); vtrig.focus(); }
        });
      }
      function select(sess) { st.session = sess; paintRows(); paintCalSlots(); paintCta(); errEl.hidden = true; }
      function byId(id) {
        for (var i = 0; i < sessions.length; i++) if (sessions[i].id === id) return sessions[i];
        return null;
      }

      /* ---- month picker, revealed only on request --------------------- */
      var months = dates.map(function (d) { return d.slice(0, 7); })
        .filter(function (v, i, a2) { return a2.indexOf(v) === i; });
      var monthAt = 0;
      function paintCal() {
        var ym = months[monthAt].split("-"), y = Number(ym[0]), mo = Number(ym[1]);
        labelEl.textContent = new Date(y, mo - 1, 1).toLocaleDateString("en-US", { month: "long", year: "numeric" });
        root.querySelector("#cal-prev").disabled = monthAt === 0;
        root.querySelector("#cal-next").disabled = monthAt === months.length - 1;
        var lead = new Date(y, mo - 1, 1).getDay(), span = new Date(y, mo, 0).getDate(), h = "";
        for (var i = 0; i < lead; i++) h += "<span></span>";
        for (var d = 1; d <= span; d++) {
          var iso = y + "-" + pad(mo) + "-" + pad(d),
            has = (byDate[iso] || []).some(function (x) { return x.seats_available > 0; });
          h += '<button type="button" class="cal-cell' +
            (st.session && st.session.local_date === iso ? " on" : "") + '" data-date="' + iso + '"' +
            (has ? "" : " disabled") + ">" + d + "</button>";
        }
        gridEl.innerHTML = h;
      }
      function paintCalSlots() {
        if (!st.session || pickEl.hidden) { calSlots.innerHTML = ""; return; }
        var day = byDate[st.session.local_date] || [];
        calSlots.innerHTML = day.map(function (x) {
          return rowHTML(x, x.id === st.session.id);
        }).join("");
      }

      var card = root.querySelector(".sps");
      var host = root.closest ? root.closest("dialog") : null;

      /* Tick the countdowns. Text only while time remains; when a slot's
         cut-off passes it becomes a locked "Booking closed" row, and if it was
         the chosen one the next bookable slot takes over — so the button can
         never offer a time checkout would refuse. Stops once this picker is
         gone from the page (a re-mount builds a new card). */
      if (ALL.some(function (x) { return msToClose(x) != null; })) {
        var closeTick = setInterval(function () {
          if (!card || !card.isConnected) { clearInterval(closeTick); return; }
          var expired = false;
          ALL.forEach(function (x) {
            if (x.seats_available > 0 && !x.closed) {
              var ms = msToClose(x);
              if (ms != null && ms <= 0) { x.closed = true; x.seats_available = 0; expired = true; }
            }
          });
          if (expired) {
            if (st.session && st.session.closed) {
              st.session = null;
              for (var ti = 0; ti < ALL.length; ti++) {
                if (ALL[ti].seats_available > 0) { st.session = ALL[ti]; break; }
              }
            }
            paintRows(); paintCalSlots(); paintCta();
            return;
          }
          root.querySelectorAll("[data-closes]").forEach(function (el) {
            var ms = Date.parse(el.getAttribute("data-closes")) - Date.now();
            if (ms <= 0) return;
            el.lastChild.textContent = closeLabel(ms);
            el.classList.toggle("hot", ms < 1800000);
            el.classList.toggle("warn", ms >= 1800000);
          });
        }, 1000);
      }
      if (host) host.classList.toggle("sps-about-on", !!ab);

      watchDialog(host);
      syncScrollLock();

      function setCalendar(open) {
        st.open = open;
        pickEl.hidden = !open;
        rowsEl.hidden = open;
        // Browsing a month needs room the three-row card does not; widen the
        // dialog and split it in two, but only where there is width to spend.
        card.classList.toggle("wide", open);
        if (host) host.classList.toggle("sps-wide", open);
        moreEl.textContent = open ? "See quick picks ▴" : "See calendar view ▾";
        if (open) {
          var i = months.indexOf((st.session ? st.session.local_date : dates[0]).slice(0, 7));
          monthAt = i < 0 ? 0 : i;
          paintCal(); paintCalSlots();
        }
      }
      moreEl.addEventListener("click", function () { setCalendar(!st.open); });

      // Redeeming a gift is a considered choice, not a quick re-book: the
      // recipient is picking a date months out, so open on the month view.
      if (opts.openCalendar) setCalendar(true);
      root.querySelector("#cal-prev").addEventListener("click", function () {
        if (monthAt > 0) { monthAt--; paintCal(); }
      });
      root.querySelector("#cal-next").addEventListener("click", function () {
        if (monthAt < months.length - 1) { monthAt++; paintCal(); }
      });
      gridEl.addEventListener("click", function (e) {
        var c = e.target.closest(".cal-cell");
        if (!c || c.disabled) return;
        select((byDate[c.dataset.date] || []).filter(function (x) { return x.seats_available > 0; })[0]);
        paintCal();
      });
      rowsEl.addEventListener("click", function (e) {
        var r = e.target.closest(".srow");
        if (r) select(byId(r.dataset.id));
      });
      calSlots.addEventListener("click", function (e) {
        var r = e.target.closest(".srow");
        if (r) { select(byId(r.dataset.id)); paintCal(); }
      });
      root.querySelector(".gctl").addEventListener("click", function (e) {
        var b = e.target.closest("button");
        if (!b || b.disabled) return;
        st.guests = Math.max(1, st.guests + Number(b.dataset.d));
        paintCta();
      });
      if (opts.onClose) root.querySelector("#sps-x").addEventListener("click", opts.onClose);
      var gateEl = gate ? root.querySelector("#sps-gate") : null;
      var gateCb = gate ? root.querySelector("#sps-gate-cb") : null;
      if (gateCb) gateCb.addEventListener("change", function () {
        if (gateCb.checked) { errEl.hidden = true; gateEl.classList.remove("bad"); }
      });
      var wgateEl = root.querySelector("#sps-wgate");
      var wgateCb = root.querySelector("#sps-wgate-cb");
      if (wgateCb) wgateCb.addEventListener("change", function () {
        if (wgateCb.checked) { errEl.hidden = true; wgateEl.classList.remove("bad"); }
      });
      /* Exposure fires from here, not from a DOM selector in the registry: the
         note lives inside a dialog that does not exist until the picker mounts,
         so a page scan would never see it. Same reason 'offer' has an empty
         sel. Skipped when a caller supplied its own note (gift redemption),
         since that arm shows no terms at all. */
      if (!opts.note && window.KS_AB_track) window.KS_AB_track("cancel", "view");
      var policyEl = root.querySelector("#sps-policy");
      if (policyEl) policyEl.addEventListener("click", function () {
        if (window.KS_AB_track) window.KS_AB_track("cancel", "click");
        var pd = document.getElementById("sps-pdlg");
        if (!pd) {
          pd = document.createElement("dialog");
          pd.id = "sps-pdlg"; pd.className = "sps-wdlg";
          pd.setAttribute("aria-label", "Cancellation policy");
          pd.innerHTML = '<div class="wh"><b>Cancellation &amp; rescheduling</b>' +
            '<button type="button" aria-label="Close">&#10005;</button></div><div class="wb"></div>';
          document.body.appendChild(pd);
          pd.querySelector(".wh button").addEventListener("click", function () { pd.close(); });
          pd.addEventListener("click", function (e) { if (e.target === pd) pd.close(); });
          watchDialog(pd);
        }
        // Rebuilt on open, not cached: the arm is fixed per visitor but the
        // body is cheap, and a stale one would be worse than free.
        pd.querySelector(".wb").innerHTML = policyHtml();
        pd.showModal();
      });
      var phoneInEl = root.querySelector("#sps-phone-in");
      if (phoneInEl) phoneInEl.addEventListener("input", function () {
        if (phoneInEl.value.replace(/\D/g, "").length >= 10) { errEl.hidden = true; phoneInEl.classList.remove("bad"); }
      });

      ctaEl.addEventListener("click", function () {
        if (!st.session) return;
        // A consent gate has to actually stop the booking, not just warn.
        if (gate && !gateCb.checked) {
          errEl.textContent = "Please confirm everyone attending is " + gate.min + " or older.";
          errEl.hidden = false;
          gateEl.classList.remove("bad"); void gateEl.offsetWidth; gateEl.classList.add("bad");
          gateCb.focus();
          return;
        }
        if (wgateCb && !wgateCb.checked) {
          errEl.textContent = "Please agree to the liability waiver to book.";
          errEl.hidden = false;
          wgateEl.classList.remove("bad"); void wgateEl.offsetWidth; wgateEl.classList.add("bad");
          wgateCb.focus();
          return;
        }
        var phoneEl = root.querySelector("#sps-phone-in");
        var phoneVal = ((phoneEl && phoneEl.value) || "").trim();
        /* Optional: leaving it blank books fine. Only a half-typed number is
           worth stopping for — that is a slip, not a decision, and a reminder
           sent to nine digits reaches nobody. */
        if (phoneEl && phoneVal && phoneVal.replace(/\D/g, "").length < 10) {
          errEl.textContent = "That mobile number looks incomplete — add the missing digits, or clear it to book without reminders.";
          errEl.hidden = false;
          phoneEl.classList.add("bad"); phoneEl.focus();
          return;
        }
        if (opts.onConfirm) {
          opts.onConfirm(st.session, st.guests, function () {
            var a = answers();
            // Guest count broken out for the studio on the Shopify line item.
            // The line quantity says the same, but staff scan the properties.
            a["Guests"] = String(st.guests);
            a["Phone"] = phoneVal;
            // Carried onto the order so the studio has the confirmation on file.
            if (gate) a["Age confirmed (" + gate.min + "+)"] = "Yes";
            // Visible waiver status for the team; the hidden twin below is what
            // the engine reads to stamp the booking's waiver.
            a["Waiver"] = "Agreed at booking";
            a["_waiver_agreed"] = "yes";
            return a;
          }, st.variant ? st.variant.id : null);
        }
      });

      root.spsError = function (msg) { errEl.textContent = msg; errEl.hidden = false; };

      /* Shared booking overlay. Callers used to each retitle their own button,
         which meant four copies of the same idea and none of them covering the
         modal. spsBusy(step) drives all of it from here.
           step 0 = holding the seat, 1 = building the cart, 2 = handing off */
      var STEPS = [
        ["Holding your spot\u2026", "Reserving the seats for 15 minutes"],
        ["Building your cart\u2026", "Adding the session to your order"],
        ["Taking you to checkout\u2026", "One moment — this page will change"],
      ];
      var busyEl = null;
      root.spsBusy = function (step) {
        var host = root.querySelector(".sps") || root;
        if (!busyEl) {
          busyEl = document.createElement("div");
          busyEl.className = "sps-busy";
          busyEl.setAttribute("role", "status");
          busyEl.setAttribute("aria-live", "polite");
          busyEl.innerHTML =
            '<div class="sps-ring"></div>' +
            '<div class="sps-busy-t"></div>' +
            '<div class="sps-busy-s"></div>' +
            '<div class="sps-steps">' +
              '<span class="sps-step"></span><span class="sps-step"></span><span class="sps-step"></span>' +
            "</div>" +
            '<div class="sps-bar"><i></i></div>';
          host.appendChild(busyEl);
        }
        var i = Math.max(0, Math.min(step | 0, STEPS.length - 1));
        busyEl.querySelector(".sps-busy-t").textContent = STEPS[i][0];
        busyEl.querySelector(".sps-busy-s").textContent = STEPS[i][1];
        busyEl.querySelectorAll(".sps-step").forEach(function (d, n) {
          d.className = "sps-step" + (n < i ? " done" : n === i ? " on" : "");
        });
        // Forced reflow rather than requestAnimationFrame: rAF is suspended in a
        // backgrounded tab, which would leave the overlay built but invisible
        // for anyone who booked, switched tabs, and came back.
        void busyEl.offsetWidth;
        busyEl.classList.add("on");
      };
      root.spsIdle = function () { if (busyEl) busyEl.classList.remove("on"); };

      /* Paging, for callers that cannot use the scroll-to-grow behaviour.
         growRows() is the same function infinite scroll calls, so both routes
         append identically and neither rebuilds rows already on screen. */
      root.spsRemaining = function () { return ALL.length - shown; };
      root.spsGrow = function () { growRows(); return ALL.length - shown; };

      /* Opened from a time the visitor has already tapped — the Focus hero's
         slot rail. Without this the modal opens on ALL[0] and the guest has to
         choose the same time a second time, which is the click the rail exists
         to remove. Grow the capped list far enough that the chosen row is
         actually in it; an unrendered selection would read as no selection. */
      if (opts.sessionId) {
        for (var pi = 0; pi < ALL.length; pi++) {
          if (String(ALL[pi].id) !== String(opts.sessionId)) continue;
          if (pi >= shown) shown = Math.min(pi + 3, ALL.length);
          st.session = ALL[pi];
          break;
        }
      }

      paintRows(); paintCta();
    },
  };
})();
